import AbsModule from '../common/AbsModule';

export default class Character extends AbsModule {
  startSetting() {
    jQuery('#nc-cnb').on('click', '.ncc-character-panel .ncc-character-panel-close', e => {
      jQuery('.ncc-character-panel').removeClass('is-active');
      this.purpleDimHide();
      return false;
    });
  }

  makeMarkup() {
    return `
        <div class="ncc-character-panel">
            <div class="ncc-character-panel-wrap">
                <a href="#" class="ncc-character-panel-close">${this.com.l10nData.Common.Close}</a>
                <div class="ncc-character-panel-header">${this.com.l10nData.Mycharacter.SelectMainCharacter}</div>
                <div class="ncc-character-list-wrap">
                    <ul class="ncc-character-list">
                        <div class="ncc-character-loading">
                            <span class="ncc-character-loader-circle"></span>
                        </div>
                    </ul>
                </div>
            </div>
        </div>`;
  }
  
  purpleDimHide() {
    const { purpleCheck } = this.com || {};
    const { isPurple } = purpleCheck;
    if(!isPurple) return;

    const isPurplePanelActive = document.querySelector('.ncc-purple-panel')?.classList?.contains('is-active');
    isPurple && !isPurplePanelActive && this.dim.openClose(false);
  }
}